import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { AddressFields, Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  enabledFiles?: boolean;
}

export const ResidentialAddressSection = ({
  countriesLoading,
  countries,
  enabledFiles,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="residentialAddressSection"
      title={t('client.client.residentialAddress.title')}
    >
      <Stack spacing={24}>
        <AddressFields
          countries={countries}
          countriesLoading={countriesLoading}
          variant="residentialAddress"
        />
        {enabledFiles && (
          <DocumentsTableFeature name="residentialAddress.proofOfResidenceFiles" />
        )}
      </Stack>
    </Section>
  );
};
